export const mypageReducer = (state = null, action) => {

    switch (action.type) {

        case "post":

            return action.payload;

        case "general":
            return action.payload;

        default:

            return state;


    }
}